import { formatEther } from 'viem';
import type { Chains } from '@soundxyz/utils/const';
import type { PaperCheckoutType } from '@graphql/reactQuery';
import { CreatePaperSuperMinterKeyDocument, gql, useMutation } from '@graphql/reactQuery';

/*#__PURE__*/ gql(/* GraphQL */ `
  mutation CreatePaperSuperMinterKey($input: PaperSuperMinterSdkClientSecretInput!) {
    paperSuperMinterSdkClientSecret(input: $input) {
      __typename
      ... on MutationPaperSuperMinterSdkClientSecretSuccess {
        data
      }
      ... on Error {
        message
      }
    }
  }
`);

export function usePaperTierCheckout({
  buyPriceWei,
  chain,
  editionAddress,
  quantity,
  releaseId,
  scheduleNumber,
  tierNumber,
  type,
}: {
  buyPriceWei: bigint;
  chain: Chains;
  editionAddress: string;
  quantity: number;
  releaseId: string;
  scheduleNumber: number;
  tierNumber: number;
  type: PaperCheckoutType;
}) {
  const { mutateAsync: createPaperSuperMinterKey, isLoading } = useMutation(
    CreatePaperSuperMinterKeyDocument,
    {},
  );

  async function getPaperKey({
    affiliate,
  }: {
    affiliate: string;
  }): Promise<{ key: string } | { error: string }> {
    const {
      data: { paperSuperMinterSdkClientSecret },
    } = await createPaperSuperMinterKey({
      input: {
        affiliate,
        releaseId,
        quantity,
        chain,
        editionAddress,
        scheduleNumber,
        tierNumber,
        totalPrice: formatEther(buyPriceWei),
        type,
      },
    });

    if (
      paperSuperMinterSdkClientSecret.__typename ===
      'MutationPaperSuperMinterSdkClientSecretSuccess'
    ) {
      return { key: paperSuperMinterSdkClientSecret.data };
    } else {
      return {
        error: paperSuperMinterSdkClientSecret.message || 'Something went wrong. Please try again.',
      };
    }
  }

  return {
    getPaperKey,
    isLoading,
  };
}
